import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Form, Row, Spin } from 'antd';

import FormDivider from '../../../components/common/formComponents/FormDivider/FormDivider';
import FormWrapper from '../../../components/common/formComponents/FormWrapper/FormWrapper';
import { ExportsFormFirstBlock } from './ExportsFormFirstBlock';
import { ExportsFormSecondBlock } from './ExportsFormSecondBlock';

import {
  useExportFieldsQuery,
  useExportTypesQuery,
} from '../../../queries/exportQueries';
import { fieldNames } from '../constants';
import { getState } from '../../../../../constants/stateMachineStates';
import { isReportParamsEmpty, normalizeReportParams } from '../utils';
import { debounce } from '../../../../../helpers/debounce';

const formItemLayout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};

export const ExportsForm = ({
  form,
  onSubmit,
  _companyId,
  setFormHasReportParams,
  isCreateLoading,
}) => {
  const { getFieldValue, validateFieldsAndScroll } = form;
  // установка значения в форму из пропа при инициализации
  // getFieldDecorator(fieldNames.company, { initialValue: companyId });

  const { data: types = [], isFetching, error, isIdle } = useExportTypesQuery();

  const handleParamsChange = debounce(() => {
    const value = getFieldValue(fieldNames.exportParams);
    const isEmpty = isReportParamsEmpty(value);
    setFormHasReportParams(!isEmpty);
  }, 1000);

  const handleSubmit = (e) => {
    e.preventDefault();
    validateFieldsAndScroll((err, fieldValues) => {
      if (!err) {
        const typeId = fieldValues[fieldNames.exportTypeId];
        const selectedType = types.find(({ id }) => id === typeId) ?? {};

        const reportParams = normalizeReportParams(
          fieldValues[fieldNames.exportParams] ?? {}
        );

        onSubmit({ reportParams, selectedType });
      }
    });
  };

  return (
    <>
      <FormWrapper
        layout="vertical"
        {...formItemLayout}
        style={{ overflow: 'hidden' }}
        onSubmit={handleSubmit}
      >
        <Col span={24}>
          <Row gutter={24}>
            <ExportsFormFirstBlock
              form={form}
              exportTypes={types}
              state={getState({
                idle: isIdle,
                loading: isFetching,
                error: Boolean(error),
              })}
            />
          </Row>
        </Col>

        <Content
          form={form}
          disabled={isCreateLoading}
          onParamsChange={handleParamsChange}
        />
      </FormWrapper>
    </>
  );
};

ExportsForm.propTypes = {
  companyid: PropTypes.number,
  form: PropTypes.any.isRequired,
  onSubmit: PropTypes.func.isRequired,
  setFormHasReportParams: PropTypes.func.isRequired,
  isCreateLoading: PropTypes.bool.isRequired,
};

function Content({ form, disabled, onParamsChange }) {
  const { getFieldValue } = form;

  const exportTypeId = getFieldValue(fieldNames.exportTypeId);

  const { data: fields, isFetching } = useExportFieldsQuery(exportTypeId);

  return (
    <>
      {Boolean(isFetching) && (
        <Spin
          style={{ width: '100%' }}
          delay={500}
        />
      )}

      {Array.isArray(fields) && (
        <>
          {fields.length > 0 ? (
            <>
              <FormDivider />

              <Row gutter={24}>
                <Col
                  sm={24}
                  md={{ offset: 4, span: 16 }}
                >
                  <ExportsFormSecondBlock
                    form={form}
                    fields={fields}
                    fieldNamePrefix={fieldNames.exportParams}
                    disabled={disabled}
                    formItemLayout={formItemLayout}
                    onChange={onParamsChange}
                  />
                </Col>
              </Row>

              <FormDivider />

              <SubmitBtn />
            </>
          ) : (
            <Col span={24}>
              <SubmitBtn textAlign="center" />
            </Col>
          )}
        </>
      )}
    </>
  );
}

function SubmitBtn({ textAlign = 'right' }) {
  return (
    <Row gutter={24}>
      <Col
        sm={24}
        md={{ offset: 4, span: 16 }}
      >
        <Form.Item
          wrapperCol={{ span: 24 }}
          style={{ textAlign }}
        >
          <Button
            htmlType="submit"
            type="primary"
          >
            Создать
          </Button>
        </Form.Item>
      </Col>
    </Row>
  );
}
